import { render, staticRenderFns } from "./RemortgagePDFpreview.vue?vue&type=template&id=5f95f0d0&scoped=true&"
import script from "./RemortgagePDFpreview.vue?vue&type=script&lang=js&"
export * from "./RemortgagePDFpreview.vue?vue&type=script&lang=js&"
import style0 from "./RemortgagePDFpreview.vue?vue&type=style&index=0&id=5f95f0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f95f0d0",
  null
  
)

export default component.exports